<!-- footer start-->
<div class="container-fluid">
  <div class="row">
    <div class="col-md-6 footer-copyright">
      <p class="mb-0">{{ copyright }}</p>
    </div>
    <div class="col-md-6">
      <p class="pull-right mb-0">v{{ version }}</p>
    </div>
  </div>
</div>
